/* eslint-disable */
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when the String length of a given `label` is invalid
 * @export
 * @class I18nInvalidLabelLengthError
 * @extends {Error}
 */
export class I18nInvalidLabelLengthError extends Error {
  /**
   * Creates an instance of I18nInvalidLabelLengthError
   * @param {string} message The Error `message`
   * @memberof I18nInvalidLabelLengthError
   */
  constructor(message) {
    super(message);
    this.name = `I18nInvalidLabelLengthError`;
  }
}

/**
 * Called when the String length of a given `label` is invalid
 * @param {string} label The invalid `label`
 * @returns {never} never
 */
const throwI18nInvalidLabelLengthError = (label) => {
  throw new I18nInvalidLabelLengthError(
    stripIndent(`
    Expected "label" to have a "length" greater than "0";
    Got: "${label}"
    `),
  );
};

export default throwI18nInvalidLabelLengthError;
